import { FieldError, FieldErrors, InternalFieldErrors } from 'react-hook-form'

/**
 * Returns the field name for the given field key & optional parent dot path
 *
 * @param {string} fieldKey
 * @param {string} [parentDotPath]
 * @returns {string}
 */
export const getFieldName = (fieldKey: string, parentDotPath?: string): string => {
  return `${parentDotPath ? `${parentDotPath}.` : ''}${fieldKey}`
}

/**
 * Returns the field error message for the given field key & optional parent dot path
 *
 * @param {string} fieldKey
 * @param {string} [parentDotPath]
 * @param {FieldErrors} [errors]
 * @returns {FieldError | undefined}
 */
export const getFieldError = (fieldKey: string, parentDotPath?: string, errors?: FieldErrors): FieldError | undefined => {
  if (!errors) return undefined

  // foo.bar.baz  => ['foo', 'bar', 'baz']
  const keys = parentDotPath?.split('.')
  let result: FieldErrors | FieldError = errors

  if (keys) {
    for (const key of keys) {
      // Check if the key exists in the result object
      if (result === null || result === undefined || typeof result !== 'object') {
        return undefined
      }

      if (key in result) {
        result = result[key] as InternalFieldErrors
      }
    }
  }

  return result?.[fieldKey] as FieldError | undefined
}
